if (!customElements.get('fullscreen-fade-slideshow')) {
  class FullscreenFadeSlideshow extends HTMLElement {
    constructor() {
      super();
      this.current = 0;
      this.timer = null;
    }

    connectedCallback() {
      this.section = this.closest('.fullscreen-fade-slideshow') || this;
      this.slides = Array.from(this.section.querySelectorAll('.fullscreen-fade-slideshow__slide'));
      this.dots = Array.from(this.section.querySelectorAll('.fullscreen-fade-slideshow__dot'));
      this.autoplay = this.section.dataset.autoplay === 'true';
      this.speed = parseInt(this.section.dataset.autoplaySpeed || '5000', 10);

      if (this.slides.length <= 1) return;

      this.bindEvents();
      this.start();

      document.addEventListener('visibilitychange', this.handleVisibilityChange);
      this.section.addEventListener('mouseenter', this.handleMouseEnter);
      this.section.addEventListener('mouseleave', this.handleMouseLeave);
    }

    disconnectedCallback() {
      this.stop();
      document.removeEventListener('visibilitychange', this.handleVisibilityChange);
      this.section?.removeEventListener('mouseenter', this.handleMouseEnter);
      this.section?.removeEventListener('mouseleave', this.handleMouseLeave);
    }

    bindEvents() {
      this.handleVisibilityChange = () => {
        if (document.hidden) {
          this.stop();
        } else {
          this.start();
        }
      };

      this.handleMouseEnter = () => this.stop();
      this.handleMouseLeave = () => this.start();

      this.dots.forEach((dot) => {
        dot.addEventListener('click', () => {
          const index = Number(dot.dataset.slideTo);
          this.goTo(index);
          this.restart();
        });
      });
    }

    goTo(index) {
      this.slides.forEach((slide, i) => {
        const isActive = i === index;
        slide.classList.toggle('is-active', isActive);
        slide.setAttribute('aria-hidden', isActive ? 'false' : 'true');
      });

      this.dots.forEach((dot, i) => {
        const isActive = i === index;
        dot.classList.toggle('is-active', isActive);
        dot.setAttribute('aria-current', isActive ? 'true' : 'false');
      });

      this.current = index;
    }

    next() {
      const nextIndex = (this.current + 1) % this.slides.length;
      this.goTo(nextIndex);
    }

    start() {
      if (!this.autoplay || this.slides.length <= 1) return;
      this.stop();
      this.timer = window.setInterval(() => this.next(), this.speed);
    }

    stop() {
      if (this.timer) {
        window.clearInterval(this.timer);
        this.timer = null;
      }
    }

    restart() {
      this.stop();
      this.start();
    }
  }

  customElements.define('fullscreen-fade-slideshow', FullscreenFadeSlideshow);
}

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.fullscreen-fade-slideshow').forEach((section) => {
    if (section.dataset.initialized === 'true') return;
    section.dataset.initialized = 'true';

    const el = document.createElement('fullscreen-fade-slideshow');
    section.appendChild(el);
  });
});